const GuildDashboard = () => {
  return (
    <>
      <section id="guia-dashboard" className="content-section">
        <div className="card mb-3">
          <div className="card-body text-center">
            <h5 className="card-title">Dashboard</h5>
          </div>
          <div className="card-body">
            <div className="card">
              <div className="card-body pt-2">
                <ul className="p-xss-0 p-md-3 justified-text">
                  <p className="mb-0">
                    <br />
                    <strong>Dashboard</strong>
                  </p>
                  <div className="d-flex justify-content-center print-image img-container">
                    <img
                      src="./res/figures/dashboard.png"
                      className="card-img-bottom img-xl"
                      alt=""
                    />
                  </div>
                  <br />
                  <ul className="p-xss-0 p-md-3 justified-text">
                    <ul className="p-xss-0 p-md-3 justified-text">
                      <li>
                        <p className="mb-0 justified-text">
                          <strong>Rede:</strong> Permite visualizar informações
                          e alterar o comportamento da rede. Configurações de
                          rede local (LAN), configurações de rede remota (WAN),
                          Ethernet e Modo de operação
                        </p>
                      </li>
                      <li>
                        <p className="mb-0 justified-text">
                          <strong>Tempo ativo:</strong> Permite visualizar o
                          tempo total de operação do equipamento desde que foi
                          ligado.
                        </p>
                      </li>
                      <li>
                        <p className="mb-0 justified-text">
                          <strong>Sistema:</strong> Permite visualizar detalhes
                          sobre o equipamento, como nome, versão do firmware e
                          termos de uso. É possível acessar as configurações de
                          sistema pelo menu lateral.
                        </p>
                      </li>
                      <li>
                        <p className="mb-0 justified-text">
                          <strong>Equipamentos conectados:</strong> Permite
                          visualizar a lista dos clientes conectados ao
                          equipamento, como suas estatísticas e sinais.
                        </p>
                      </li>
                    </ul>
                  </ul>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default GuildDashboard;
